module.exports = __webpack_public_path__ + "img/PorkTheUnitedKingdom.9859f6e5.png";